export interface Project {
  id: string
  title: string
  location: string
  status: 'Active' | 'Piloting' | 'Design'
  description: string
  impact: {
    co2Offset: number
    hectares: number
    communities: number
    biodiversitySpecies: number
  }
  services: string[]
  methodology: string
  startYear: number
  sector: string
}

export const PROJECTS: Project[] = [
  {
    id: 'liza-carbon',
    title: 'LIZA Carbon Project',
    location: 'Republic of the Congo',
    status: 'Active',
    description: 'A large-scale ARR and REDD+ project in the Congo Basin focused on afforestation, reforestation, and avoided deforestation. The LIZA Carbon Project protects critical tropical rainforest while providing sustainable livelihoods for indigenous communities.',
    impact: {
      co2Offset: 207510,
      hectares: 42600,
      communities: 2400,
      biodiversitySpecies: 4
    },
    services: ['Feasibility Studies', 'Project Design', 'Monitoring & Verification', 'Implementation'],
    methodology: 'VM0007 - REDD+ Methodology Framework',
    startYear: 2023,
    sector: 'Afforestation & Reforestation',
  },
  {
    id: 'sahel-restoration',
    title: 'Sahel Reforestation Initiative',
    location: 'Senegal & Mali',
    status: 'Piloting',
    description: 'Community-led reforestation and agroforestry programme across the Sahel region, combining carbon sequestration with food security and livelihood improvements.',
    impact: { co2Offset: 85000, hectares: 25000, communities: 8, biodiversitySpecies: 45 },
    services: ['Feasibility Studies', 'Project Design', 'Capacity Building'],
    methodology: 'AR-ACM0003 - A/R Methodology',
    startYear: 2024,
    sector: 'Afforestation & Reforestation',
  },
  {
    id: 'blue-carbon-mozambique',
    title: 'Blue Carbon Coastal Programme',
    location: 'Mozambique',
    status: 'Design',
    description: 'Mangrove restoration and coastal wetland conservation project, generating blue carbon credits while protecting coastal communities from climate impacts.',
    impact: { co2Offset: 35000, hectares: 8000, communities: 5, biodiversitySpecies: 120 },
    services: ['Feasibility Studies', 'Project Design', 'Permitting & Compliance'],
    methodology: 'VM0033 - Tidal Wetland Conservation',
    startYear: 2025,
    sector: 'Blue Carbon Capture',
  },
  {
    id: 'east-africa-biochar',
    title: 'East Africa Biochar Initiative',
    location: 'Kenya & Tanzania',
    status: 'Piloting',
    description: 'Organic waste-to-biochar programme converting agricultural residues into stable carbon through pyrolysis. Generates high-quality carbon removal credits while improving soil fertility for smallholder farmers.',
    impact: { co2Offset: 18000, hectares: 5000, communities: 12, biodiversitySpecies: 30 },
    services: ['Feasibility Studies', 'Adaptive Project Design', 'Carbon Credit Trading'],
    methodology: 'Puro.earth Biochar Methodology',
    startYear: 2025,
    sector: 'Biochar & BECCS',
  }
]
